<template>
  <div class="col-12 row">
    <div
      ref="textPost"
      :class="{
        'col-12 pt-3 px-0': true,
        'text': !showing,
        'text-open': showing
      }"
      v-html="text"
    ></div>
    <div class="bg-akdemica show-more col-12 text-center small text-white" v-if="showMore" @click="toggleShow">
      <span v-if="!showing"><span class="fa fa-caret-down"></span> Ver Mais</span>
      <span v-else><span class="fa fa-caret-up"></span> Ver Menos</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      required: true
    }
  },
  data () {
    return {
      showing: false,
      showMore: false
    }
  },
  methods: {
    countLines: function () {
      let h = this.$refs['textPost'].offsetHeight
      this.showMore = h >= 100
    },
    toggleShow: function () {
      this.$set(this, 'showing', !this.showing)
      // this.showing = !this.showing
    }
  },
  mounted () {
    this.countLines()
  }
}
</script>

<style>

</style>
